import authService from '../api-authorization/AuthorizeService'
//import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';

export default class ReporteVariantiService {
    async ReporteVarianti(semana) {
        const token = await authService.getAccessToken();
        const queryString = '?semana_Id=' + semana.semana_Id;
        const reporteResponse = await fetch('api/ReporteAdmin/ReporteVarianti' + queryString, {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });

        const heading = [['Codigo TMU', 'VendorCode', 'VendorName', 'Numero artico', 'Numero prodotto', 'Numero Varianti', 'Cerca nome',
            'Varietà', 'Origine', 'Calibro', 'Marca', 'Certificazione', 'Cat.', 'Confezione', 'Volume', 'Colli/Pallet',
            'Particolarità', 'Nome prodotto', 'Peso netto', 'Tara', 'Descrizione'
        ]];

        let rows = await reporteResponse.json();
        rows.forEach(function (v) {
            // Delete excluded properties
            delete v.semana_Id;
           

            return v;
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(worksheet, heading);
        XLSX.utils.sheet_add_json(worksheet, rows, { origin: 'A2', skipHeader: true });

        const style_h1 = {
            fill: { fgColor: { rgb: "92D050" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: { name: 'Calibri', sz: 11, bold: true },
            border: { top: { style: "thin", color: { auto: 1 } }, right: { style: "thin", color: { auto: 1 } }, bottom: { style: "thin", color: { auto: 1 } }, left: { style: "thin", color: { auto: 1 } } }
        };

        const columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V"];
        var wscols = [];
        for (let i = 0; i < columns.length; i++) {
            if (i == 2) {
                wscols.push({ wch: 30 })
            }
            else if (i == 4) {
                wscols.push({ wch: 50 })
            }
            else if (i == 7) {
                wscols.push({ wch: 50 })
            }
            else if (i == 20) {
                wscols.push({ wch: 80 })
            }
            else {
                wscols.push({ wch: 20 })
            }

        }
        worksheet['!cols'] = wscols;

        columns.forEach((col, i) => {
            const cell = col + "1";
            if (worksheet[cell]) {
                worksheet[cell].s = style_h1;
            }
        });

        worksheet['!autofilter'] = { ref: "A1:V1" };
        XLSX.utils.book_append_sheet(workbook, worksheet, 'ReporteVarianteProveedor');
        XLSX.writeFile(workbook, "VariantesProveedorReporte_" + semana.nombre + ".xlsx", { compression: true });
    }
}
